import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";

// Public pages
import Home from "@/pages/public/Home";
import ProjectsPage from "@/pages/public/ProjectsPage";
import ProjectDetail from "@/pages/public/ProjectDetail";
import TeamPage from "@/pages/public/TeamPage";
import ContactPage from "@/pages/public/ContactPage";
import StaffLogin from "@/pages/public/StaffLogin";
import ForgotPassword from "@/pages/public/ForgotPassword";
import ResetPassword from "@/pages/public/ResetPassword";
import PublicLayout from "@/components/public/PublicLayout";

// Portal
import PortalLayout from "@/components/portal/PortalLayout";
import Dashboard from "@/pages/portal/Dashboard";
import DepartmentPage from "@/pages/portal/DepartmentPage";
import PortalProjects from "@/pages/portal/PortalProjects";
import PortalProjectEditor from "@/pages/portal/PortalProjectEditor";
import PortalTeam from "@/pages/portal/PortalTeam";
import PortalEnquiries from "@/pages/portal/PortalEnquiries";
import PortalStaff from "@/pages/portal/PortalStaff";
import PortalSiteContent from "@/pages/portal/PortalSiteContent";
import PortalNotifications from "@/pages/portal/PortalNotifications";

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-stone">
        <div className="font-mono text-xs tracking-widest uppercase">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/staff/login" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public site */}
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/projects" element={<ProjectsPage />} />
            <Route path="/projects/:id" element={<ProjectDetail />} />
            <Route path="/team" element={<TeamPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Route>

          {/* Auth pages (no layout chrome) */}
          <Route path="/staff/login" element={<StaffLogin />} />
          <Route path="/staff/forgot-password" element={<ForgotPassword />} />
          <Route path="/staff/reset-password" element={<ResetPassword />} />

          {/* Portal */}
          <Route
            path="/portal"
            element={
              <ProtectedRoute>
                <PortalLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="departments/:dept" element={<DepartmentPage />} />
            <Route path="projects" element={<PortalProjects />} />
            <Route path="projects/new" element={<PortalProjectEditor />} />
            <Route path="projects/:id" element={<PortalProjectEditor />} />
            <Route path="team" element={<PortalTeam />} />
            <Route path="enquiries" element={<PortalEnquiries />} />
            <Route path="staff" element={<PortalStaff />} />
            <Route path="site-content" element={<PortalSiteContent />} />
            <Route path="notifications" element={<PortalNotifications />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="top-right" richColors closeButton />
      </BrowserRouter>
    </AuthProvider>
  );
}
